import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
const conditions = ['Sigues dudando en tus decisiones', 'No te aporta claridad', 'No mejora tu práctica clínica'];
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-138" data-mp="24ldjmyfsqer3">
      <div className="mx-auto max-w-2xl" data-id="element-139" data-mp="29eq5x1x069go">
        <div className="rounded-3xl border-2 border-navy/10 bg-white p-6 text-center sm:p-8" data-id="element-140" data-mp="29frg74672rxc">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brandred/10" data-id="element-141" data-mp="2efduzi1o8g89">
            <ShieldCheckIcon className="h-8 w-8 text-brandred" strokeWidth={2} data-id="element-142" data-mp="2ob7ghqxdbk26" />
          </span>
          <h2 className="mt-4 font-display text-[26px] font-black leading-tight tracking-tight text-navy sm:text-3xl" data-id="element-143" data-mp="2scsph16s7e73">
            Garantía Total de 7 Días
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-navy/65" data-id="element-144" data-mp="tyzexuqjk4xf">
            Puedes probar el sistema sin riesgo. Si al revisarlo sientes que:
          </p>
          <ul className="mx-auto mt-4 max-w-sm space-y-2 text-left" data-id="element-145" data-mp="3sloqzl1lb4fx">
            {conditions.map(c => <li key={c} className="rounded-xl bg-cream px-4 py-2.5 text-[13.5px] font-medium text-navy/70" data-id="element-146" data-mp="3ntoqnrhly9it">
                {c}
              </li>)}
          </ul>
          <p className="mt-4 text-[15px] leading-relaxed text-navy/65" data-id="element-147" data-mp="3dydbj82af0aj">
            Solicitas la devolución y listo. Sin trámites complicados. Sin condiciones ocultas.
          </p>
          <p className="mt-4 font-display text-lg font-black text-navy" data-id="element-148" data-mp="ah4wevyy2eji">
            El riesgo es nuestro. <span className="italic text-brandred" data-id="element-149" data-mp="5ffin8kc7mrq">La decisión es tuya.</span>
          </p>
        </div>

        <TransformCTA text="Quiero probarlo sin riesgo durante 7 días" data-id="element-150" data-mp="h4ad29oxkbm" />
      </div>
    </section>;
}